import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) { setError("Mínimo 6 caracteres"); return; }
    if (pwd !== pwd2) { setError("Las contraseñas no coinciden"); return; }
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pwd });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <Card className="max-w-md"><CardContent className="p-6 text-center text-sm">
          Link inválido o sin token. <Link to="/forgot-password" className="text-blue-600 underline">Pedir uno nuevo</Link>.
        </CardContent></Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-slate-100">
      <Card className="w-full max-w-md" data-testid="reset-password-page">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5" /> Nueva contraseña</CardTitle>
          <CardDescription>Elegí una contraseña de al menos 6 caracteres.</CardDescription>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="space-y-3 text-center py-6">
              <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
              <p className="text-sm">Contraseña actualizada. Te llevamos al login…</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Nueva contraseña</Label>
                <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="new-password" />
              </div>
              <div>
                <Label>Confirmar</Label>
                <Input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="confirm-password" />
              </div>
              {error && <p className="text-sm text-red-500">⚠️ {error}</p>}
              <Button type="submit" disabled={loading} className="w-full" data-testid="reset-submit">
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Cambiar contraseña
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
